module.exports = __webpack_public_path__ + "img/zhengzhou-zz.d4322efd.webp";